import { camelize } from 'humps';

import { getFieldValue, SearchItemValue } from '~/redux/api/methods/evisearch';

export const camelizeFieldId = (fieldId: string) => {
  return camelize(fieldId.replace(/_(Document|Ticket)$/, ''));
};
/*
 * Search results come in a complicated nested structure. This function unwraps the values
 * so it's easier to look up the value of a field without having to navigate the nested structure.
 */
export const flattenSearchSelectedItemValues = (
  selectedFieldValues?: Record<string, SearchItemValue>,
): Record<string, string | number> => {
  if (!selectedFieldValues) {
    return {};
  }

  const fields = Object.entries(selectedFieldValues)
    .map(([key, { value }]) => [camelizeFieldId(key), getFieldValue(value)])
    .filter(([_, value]) => typeof value !== 'undefined');

  return Object.fromEntries(fields);
};
